if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Validate required options (gender, size, width)
        const productInfo = this.closest('product-info');
        if (productInfo?.validateRequiredOptionsAndScroll && !productInfo.validateRequiredOptionsAndScroll()) {
          return;
        }

        if (productInfo?.requiresManualVariantSelection?.() && !this.variantIdInput.value) {
          productInfo._requiredOptionErrorsVisible = true;
          productInfo.updateRequiredOptionValidation(true);
          const missing = productInfo.getMissingRequiredOptions();
          if (missing.length) {
            productInfo.scrollToRequiredOption(missing[0]);
          }
          return;
        }

        if (!productInfo?.requiresManualVariantSelection?.()) {
          const variantSelects = productInfo?.querySelector('variant-selects') || document.querySelector('variant-selects');
          if (variantSelects) {
            // Get all option groups (excluding Color which is swatch type)
            const buttonFieldsets = variantSelects.querySelectorAll('fieldset.product-form__input--pill');
            const dropdownSelects = variantSelects.querySelectorAll('select.select__select');
            
            // Check if Size and Width are selected
            let sizeSelected = false;
            let widthSelected = false;
            
            // Check button options (Size and Width) - they have h2 labels inside the fieldset
            buttonFieldsets.forEach(fieldset => {
              // Find the h2 label inside this fieldset
              const h2Label = fieldset.querySelector('.select_gender');
              if (h2Label) {
                const labelText = h2Label.textContent.toLowerCase();
                const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
                
                if (labelText.includes('size') && checkedInput) {
                  sizeSelected = true;
                } else if (labelText.includes('width') && checkedInput) {
                  widthSelected = true;
                }
              }
            });
            
            // Check dropdown options
            dropdownSelects.forEach(select => {
              const label = select.closest('.product-form__input--dropdown')?.querySelector('.form__label');
              if (label) {
                const labelText = label.textContent.toLowerCase();
                const selectedValue = select.value;
                if (labelText.includes('size') && selectedValue && selectedValue !== '') {
                  sizeSelected = true;
                } else if (labelText.includes('width') && selectedValue && selectedValue !== '') {
                  widthSelected = true;
                }
              }
            });
            
            // If Size or Width is not selected, show modal
            if (!sizeSelected || !widthSelected) {
              if (window.SelectionRequiredModal && typeof window.SelectionRequiredModal.open === 'function') {
                window.SelectionRequiredModal.open();
              } else {
                alert('Please select size before adding to cart.');
              }
              return;
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // For unisex products: add selected gender+size mapping as line item property
        const activeGenderBtn = productInfo?.querySelector('.js-unisex-gender-toggle.g-active');
        if (activeGenderBtn) {
          const gender = activeGenderBtn.dataset.genderLabel || activeGenderBtn.textContent.trim();
          const normalizedGender = (gender || '').toString().trim().toLowerCase();

          // Find selected Size (radio pill or dropdown)
          const variantSelects =
            productInfo?.querySelector('variant-selects') || this.closest('variant-selects') || document.querySelector('variant-selects');
          let selectedSize = '';
          if (variantSelects) {
            const sizeRadio = variantSelects.querySelector(
              'fieldset.product-form__input--pill input[type="radio"][data-option-name][data-option-display-value]:checked'
            );
            if (sizeRadio && (sizeRadio.dataset.optionName || '').toLowerCase().includes('size')) {
              selectedSize = (sizeRadio.value || '').toString().trim();
            } else {
              const selects = Array.from(variantSelects.querySelectorAll('select.select__select'));
              const sizeSelect = selects.find((select) => {
                const label = select.closest('.product-form__input--dropdown')?.querySelector('.form__label');
                return label && label.textContent.toLowerCase().includes('size');
              });
              if (sizeSelect) selectedSize = (sizeSelect.value || '').toString().trim();
            }
          }

          const parseNum = (v) => {
            const n = parseFloat(String(v).trim());
            return Number.isFinite(n) ? n : null;
          };
          const fmt = (n) => (Number.isInteger(n) ? String(n) : String(Math.round(n * 2) / 2));

          const baseNum = parseNum(selectedSize);
          const offset = 1.5;

          let genderPropertyValue = (gender || '').toString().trim();
          if (baseNum !== null) {
            const men = fmt(baseNum);
            const women = fmt(baseNum + offset);

            if (normalizedGender === 'women' || normalizedGender === 'woman' || normalizedGender === 'female') {
              // Women tab: displayed = women, variant = men (base)
              genderPropertyValue = `Women ${women} / Men ${men}`;
            } else {
              // Men tab: displayed = men, variant = men (base)
              genderPropertyValue = `Men ${men} / Women ${women}`;
            }
          }

          if (genderPropertyValue) formData.append('properties[Gender]', genderPropertyValue);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, soft = false) {
        if (disable) {
          if (soft) {
            // Visually muted but still clickable so validation can run
            this.submitButton.removeAttribute('disabled');
            this.submitButton.classList.add('product-form__submit--awaiting-selection');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.classList.remove('product-form__submit--awaiting-selection');
          }
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('product-form__submit--awaiting-selection');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
